"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
// import { createOsmosysLogger } from '@osmosys/utils';
const apollo_client_1 = require("apollo-client");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_hanger_1 = require("react-hanger");
const react_loops_1 = require("react-loops");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../comps/reusables");
const react_2 = require("@osmosys/react");
const ResourceListContext = react_1.default.createContext({
    page: 0,
    result: {},
    setState: () => { },
    state: {},
});
const useResourceListContext = () => {
    const context = react_1.default.useContext(ResourceListContext);
    if (!context) {
        throw new Error('ResourceListContext cannot be used outside of the ResourceList component');
    }
    return context;
};
exports.ResourceListOuter = () => {
    return props => {
        return react_1.default.createElement(ResourceList, Object.assign({}, props));
    };
};
function ResourceList(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { variables, children, keys, pageSize } = props, rest = tslib_1.__rest(props, ["variables", "children", "keys", "pageSize"]);
    const { setState, state } = react_hanger_1.useSetState({});
    // const { setState, state } = useSetState<FData>({} as any);
    const page = react_hanger_1.useNumber(0, { lowerLimit: 0, step: 1 });
    const context = {
        keys,
        page,
        pageSize: props.pageSize,
        setState,
        state,
    };
    const newVariables = variables instanceof Function ? variables(context) : variables;
    const { query } = rest, queryProps = tslib_1.__rest(rest, ["query"]);
    const result = react_hooks_1.useQuery(query, Object.assign(Object.assign({}, queryProps), { variables: Object.assign({ skip: props.pageSize * page.value, take: props.pageSize }, (newVariables || {})) }));
    return (react_1.default.createElement(ResourceList.Inner, { context: Object.assign(Object.assign({}, context), { result }) }, children));
}
exports.ResourceList = ResourceList;
ResourceList.defaultProps = {
    pageSize: 20,
};
ResourceList.Inner = ({ context: { result: { error, loading, networkStatus }, }, context, children, }) => {
    return (react_1.default.createElement(ResourceListContext.Provider, { value: context },
        react_1.default.createElement(react_1.default.Fragment, null,
            children,
            error && react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: error }),
            networkStatus === apollo_client_1.NetworkStatus.loading && loading && react_1.default.createElement(reusables_1.Loading, null))));
};
ResourceList.Detail = (props) => {
    const { keys, result } = useResourceListContext();
    const items = result.data[keys.item];
    const empty = react_1.default.createElement(react_1.default.Fragment, null, "No results");
    if (!items) {
        return empty;
    }
    return (react_1.default.createElement(react_loops_1.For, { of: items, ifEmpty: empty }, (d, { index }) => {
        const rendered = props.children({ data: d, index });
        if (props.component) {
            const Injectable = props.component;
            return react_1.default.createElement(Injectable, null, rendered);
        }
        return rendered;
    }));
};
/* ------------------------------- EmptyState ------------------------------- */
ResourceList.EmptyState = ({ children }) => {
    const { keys, result } = useResourceListContext();
    if (!result.data ||
        !result.data[keys.item] ||
        ((result.data || {})[keys.item] || []).length === 0) {
        return children;
    }
    return null;
};
/* ------------------------------ SuccessState ------------------------------ */
ResourceList.SuccessState = ({ children }) => {
    const { result } = useResourceListContext();
    if (result.data) {
        return children;
    }
    return null;
};
/* ------------------------------ NonEmptyState ----------------------------- */
ResourceList.NonEmptyState = ({ children }) => {
    const { keys, result } = useResourceListContext();
    if (((result.data || {})[keys.item] || []).length > 0) {
        return children;
    }
    return null;
};
/* ------------------------------- Pagination ------------------------------- */
ResourceList.Pagination = () => {
    const { keys, result, page, pageSize } = useResourceListContext();
    // Set page value to max if it goes over
    const pageCount = keys.count
        ? Math.ceil(result.data[keys.count] / pageSize)
        : 0;
    react_1.default.useEffect(() => {
        if (pageCount < page.value) {
            page.setValue(pageCount - 1);
        }
    }, [page, page.value, pageCount]);
    // Render
    return (react_1.default.createElement(react_2.OsmosysPagination, { forcePage: page.value, pageCount: pageCount, onPageChange: p => {
            page.setValue(p);
        } }));
};
ResourceList.Count = (props) => {
    const { result, keys } = useResourceListContext();
    return (react_1.default.createElement(ResourceList.SuccessState, null, props.children
        ? props.children(result.data[keys.count])
        : result.data[keys.count] || null));
};
/* -------------------------------- PageSize -------------------------------- */
ResourceList.PageSize = () => {
    const { pageSize } = useResourceListContext();
    return react_1.default.createElement(react_1.default.Fragment, null, pageSize);
};
ResourceList.Filter = ({ options, name, defaultValue, placeholder, }) => {
    const { setState, state } = useResourceListContext();
    const input = react_hanger_1.useInput(state[name] || defaultValue || '');
    react_1.useEffect(() => {
        setState({
            [name]: input.value,
        });
    }, [input.value, name, setState]);
    return (react_1.default.createElement(reactstrap_1.FormGroup, { className: "ml-2" },
        react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: options ? 'select' : 'text', options: options, autoComplete: "off", placeholder: placeholder }, input.eventBind, { style: { maxWidth: 200 } }), (options || []).map(opt => {
            return (react_1.default.createElement("option", { key: opt.value, value: opt.value }, opt.label));
        }))));
};
exports.ResourceListUpDown = (_a) => {
    var { dir, toggle } = _a, restOfTheProps = tslib_1.__rest(_a, ["dir", "toggle"]);
    // const ref = React.useRef(null);
    const icon = (isHover) => (react_1.default.createElement("a", { className: classnames_1.default(isHover ? 'text-primary' : 'text-dark'), href: "#", onClick: e => {
            e.preventDefault();
            toggle();
        } },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: dir === 'ASC'
                ? (pro_solid_svg_icons_1.faSortUp || pro_solid_svg_icons_1.faCaretSquareDown)
                : pro_solid_svg_icons_1.faSortDown || pro_solid_svg_icons_1.faCaretSquareUp }, restOfTheProps))));
    const [hoverableIconComp] = react_use_1.useHover(icon);
    return hoverableIconComp;
};
ResourceList.TableHeader = ({ cells }) => {
    return (react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", { style: { width: '100%' } }, cells.map(c => {
            return (react_1.default.createElement("th", { key: c.name, style: {
                    width: typeof c.width === 'number' ? `${c.width}%` : c.width,
                } }, c.label));
        }))));
};
//# sourceMappingURL=ResourceList.js.map